import ShareButton, { ShareButtonProps } from '@/components/ShareButton';
import { ShareProps, useApplicationContainer } from 'containers/ApplicationContainer';
import { ReactNode } from 'react';

export default function ApplicationShareButton({
  children: exportLinks,
  className,
  ...props
}: Omit<ShareProps, 'exportLinks'> & Omit<ShareButtonProps, 'onClick'> & { children?: ReactNode }) {
  const [, { handleShare }] = useApplicationContainer();

  return <ShareButton onClick={() => handleShare({ ...props, exportLinks })} className={className} />;
}
